import { type PriceBook } from '@snap-types/models/price-book';
import { Decimal, ZERO } from '@snap-types/types/decimal';

export function convertDefaultPriceToQuantityBreak(entry: PriceBook) {
  if (entry.default_unit_price && entry.default_unit_price.gt(ZERO)) {
    return {
      quantity: new Decimal(1),
      unitPrice: entry.default_unit_price,
    };
  }

  return null;
}
